import { Component, OnInit, Renderer2, AfterViewInit, OnDestroy, isDevMode } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { Authenticationservice } from '../../core/services/authentication.service';
import { BrdsqlService } from 'src/app/core/services/brdsql.service';

declare var $: any;
declare var AdminLTE: any; // Declaring AdminLTE variable
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit, AfterViewInit, OnDestroy {
  isExpanded = true;
  // appVersion: any;
  userdata: any;
  constructor(
    private router: Router,
    private auth: Authenticationservice,
    private brdservice: BrdsqlService,
    private renderer: Renderer2
  ) {
    let userdata: any = this.auth.Authention();
    let check: any = this.auth.Alertreload();

    this.name = userdata.supname;
    this.photourl = userdata.suppic_url;
    this.actionlevel = userdata.userlevel;

    this.userdata = userdata;
  }

  // ข้อมูลจากออดิต สถานะถึงผู้จัดการโซน
  cntAuditAlert = 0;
  alertFromAudit(): void {
    let yearid = localStorage.getItem('yearCr');
    let supzone = localStorage.getItem('supzone');
    this.brdservice.alertFromAudit(yearid, supzone)
      .subscribe({
        next: (data: any) => {
          this.cntAuditAlert = data.rowsAffected;
          // console.log('dataFrom audit :' ,x);
        },
        error: (e) => console.error(e)
      });
  };
  // ++++++++ / ktd Code +++++++++++

  // username:any;
  photourl: string;
  name: string;
  orther = true; // อื่น ๆ 
  manager = true; // หัวหน้าเขต
  pathhead = true;
  headmanager = true; // ผอ หัวหน้าส่วน
  pr = true; // ประชาสัมพันธ์
  actionlevel: string;;
  academic = true; // วิชาการ
  finance = true; // สินเชื่อ
  headerfinance = true; // สินเชื่อ
  supporter = true;
  director = false;
  private routerEventsSub?: Subscription;

  enabled = [false, false];
  ngOnInit(): void {
    let location = window.location.hostname;
    console.log('Running with :', location);
    if (location === 'localhost') {
      this.enabled[0] = true;
    }
    /*if (isDevMode()) {      
      console.log('Running in development mode');
    } else {
      //console.log('Running in production mode');
    }*/

    let lvl = this.actionlevel;
    if (lvl == '8' || lvl == '4') { this.pr = false; }
    if (lvl == '8' || lvl == '99') {
      this.orther = false;
    }
    if (lvl == '5' || lvl == '6' || lvl == '7' || lvl == '9' || lvl == '10') {
      this.finance = false;
      if (lvl == '7' || lvl == '9' || lvl == '10') { this.headerfinance = false; }
    }
    if (lvl == '13' || lvl == '14' || lvl == '15') {
      this.manager = false;
      this.orther = false;
    }
    if (lvl == '11') {
      this.manager = false;
      this.orther = false;
    }
    if (lvl == '15') {
      this.manager = false;
      this.orther = false;
      this.pathhead = false;
    }
    if (lvl == '12') {
      this.manager = false;
      this.orther = false;
      this.headmanager = false;
    }
    if (lvl == '1') {
      this.manager = true;
    }
    if (lvl == '12') {
      this.director = true; // ผอ.ฝ่ายจัดหาวัตถุดิบ
    }
    if (lvl == '1' || lvl == '14' || lvl == '15') {
      this.supporter = false;
    }
  }

  ngAfterViewInit(): void {
    // Ensure AdminLTE widgets (treeview, pushmenu, layout) are bound after Angular renders.
    this.refreshAdminLTE();
    this.routerEventsSub = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => setTimeout(() => this.refreshAdminLTE(), 0));
  }

  ngOnDestroy(): void {
    this.routerEventsSub?.unsubscribe();
  }

  onlinereport = false;
  formreport = false;
  tabledata = false;

  accept = false;

  activetab = 0;


  financeboard() {
    this.router.navigateByUrl("/finance");
    this.activetab = 8;
  }

  showFormEditPlot_manager() {
    this.router.navigateByUrl("/editplotmanager");
    if (this.userdata.userlevel == 14) {
      this.router.navigateByUrl("/editplotmanager");
    }
    else if (this.userdata.userlevel == 15) {
      this.router.navigateByUrl("/editplotpart");
    }
  }

  private refreshAdminLTE(): void {
    try {
      if (typeof $ !== 'undefined' && $.fn?.Treeview) {
        $('[data-widget="treeview"]').Treeview();
      }
      if (typeof $ !== 'undefined' && $.fn?.PushMenu) {
        $('[data-widget="pushmenu"]').PushMenu();
      }
      if (typeof $ !== 'undefined' && $.fn?.Layout) {
        $('.wrapper').Layout();
      }
    } catch (err) {
      console.error('AdminLTE init failed', err);
    }
  }

}

